const state = {
  versions: {appVersion: '--', apiVersion: '--', serverVersion: '--'}
}

const mutations = {
  updateAppVersion (state, version) {
    state.versions.appVersion = version
  },
  updateServerVersion (state, version) {
    state.versions.serverVersion = version
  },
  updateApiVersion (state, version) {
    state.versions.apiVersion = version
  }
}

export default {
  state,
  mutations
}
